export const equipmentYardKeys = {
    all: ['equipment-yards'] as const,
    active: () => [...equipmentYardKeys.all, 'active'] as const,
    allList: () => [...equipmentYardKeys.all, 'all'] as const,
}
